/* Handle some footer related stuff like toggling menus */

class ProfetFooter {
	constructor() {
		this.buttons = document.querySelectorAll('.toggle-footer-menu');
	}
	init() {
		if (!this.buttons.length) {
			return;
		}
		this.handleClicks();
	}
	handleClicks() {
		for (let i = 0; i < this.buttons.length; i++) {
			let button = this.buttons[i];
			button.addEventListener('click', (event) => {
				event.preventDefault();
				let footerMenuContainer = button.closest('.footer-menu');
				if (footerMenuContainer) {
					footerMenuContainer.classList.toggle('toggled');
				}
			});
		}
	}
}
window.addEventListener('load', () => {
	window.profetFooter = new ProfetFooter();
	window.profetFooter.init();
});
